/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Board_Zoom_OutInputs */

const cs_pipelines_board_zoom_out = /** @type {(inputs: Pipelines_Board_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oddálit`)
};

const en_pipelines_board_zoom_out = /** @type {(inputs: Pipelines_Board_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom out`)
};

/**
* | output |
* | --- |
* | "Zoom out" |
*
* @param {Pipelines_Board_Zoom_OutInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_board_zoom_out = /** @type {((inputs?: Pipelines_Board_Zoom_OutInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Board_Zoom_OutInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_board_zoom_out(inputs)
	return cs_pipelines_board_zoom_out(inputs)
});